export default "__VITE_ASSET__de0de020__"